import React from 'react';

function Footer(props){
    return (
        <footer className="footer mt-auto py-3 bg-dark">
            <div className="container">
                <div className="text-center">
                    <span className="text-muted">UZ WIEA Jakub Błaszyk 2023 v1.09</span>
                </div>
            </div>
        </footer>
    )
}

export default Footer;

